// import addDashboardCnBtn from '@/pages/datalab/assets/img/home/addDashboardCnBtn.svg';
// import addDashboardCnTab from '@/pages/datalab/assets/img/home/addDashboardCnTab.svg';
// import addDashboardCnTabItem from '@/pages/datalab/assets/img/home/addDashboardCnTabItem.svg';
// import addDashboardTitleCn from '@/pages/datalab/assets/img/home/addDashboardTitleCn.svg';
// // TODO:待迁移常量文件，目前这块如果在GlobalPositioningGuidance迁出，会丢失元素定位，待查明原因
// export const ADD_DASHBOARD_CONFIG = {
//   highlightElements: [
//     {
//       element: document.querySelector(`.dbl-datalab-guide-title`),
//       padding: {
//         paddingLeft: 5,
//         paddingRight: 5,
//       },
//       hasRadius: true,
//       image: addDashboardTitleCn,
//       style: {
//         left: '20px',
//         position: 'absolute',
//       },
//     },
//     {
//       element: document.querySelector(`.tea-tabs__scroll-area`),
//       hasRadius: true,
//       image: addDashboardCnTab,
//       style: {
//         right: '-50px',
//         position: 'absolute',
//       },
//     },
//     {
//       element: document.querySelector(`.dbl-item-card`),
//       hasRadius: true,
//       image: addDashboardCnTabItem,
//       style: {
//         right: '-50px',
//         position: 'absolute',
//       },
//     },
//   ],
//   extImage: {
//     image: addDashboardCnBtn,
//     placement: 'top-end',
//     style: { position: 'relative', top: '10px', left: '30px' },
//   },
//   element: () => document.querySelector(`.dbl-chart-nodata-btn`),
//   padding: {
//     paddingTop: 10,
//     paddingRight: 10,
//     paddingBottom: 10,
//     paddingLeft: 10,
//   },
//   placement: 'bottom-center',
//   placementOffset: [10, 20],
// };

export const ADD_DASHBOARD_DEMO_LIST = {
  data_list: [
    {
      task_id:
        '4b3c352bcfff0aaac885c6c5e74a654c4584f24a47f56588f582ecb8e55bf293',
      dashboard_uuid: 0,
      dataset_uuid: '334fcaeb-34f0-4df7-89ee-1368f8953666',
      package_uuid: 0,
      type: 0,
      game_code: 'demo',
      name: 'DAU BreakdownDAU BreakdownDAU Break...',
      name_cn: 'DAU BreakdownDAU BreakdownDAU Break...',
      permission: '仅自己可见',
      permission_en: 'Visible to Me Only',
      business_type: 0,
      label: '付费',
      create_time: '2024-05-14 10:51:48',
      user_id: '11625',
      owner: 'sallyxue',
      filter_old: '',
      data_package_infos: '[]',
      chart_type: 'Table',
      statistical_metrics: 't0_channel_name',
      table_infos:
        '[{"table_name":"feeds","table_id":"c73dd2b4-60f5-44f9-81f0-2709367f3163","table_code":"t0","granularity":"day","connect_type":"","on":[],"only_one_table":true}]',
      column_infos: '{"saveRowLimits":{"sallyxue":5000}}',
      use_report_name: ['sallyxue'],
      table_name_list: ['feeds'],
      chart_dataset_list: [
        {
          table_id: 'c73dd2b4-60f5-44f9-81f0-2709367f3163',
          table_code: 't0',
          table_name: 'feeds',
        },
      ],
      editable_person: '',
      editable_person_name: '',
      editable_person_list: [
        {
          user_id: '2000357',
          user_name: 'sallyxue',
          permission: ['read', 'edit', 'read', 'delete'],
        },
      ],
      editable_person_name_list: ['sallyxue'],
      is_edit: false,
      access: true,
      read: true,
      edit: true,
      delete: true,
      publish: true,
    },
  ],
};
export const SHARE_DASHBOARD_DEMO_LIST = [
  {
    id: '68631f696a470bb30662c9f9b5708c7527a984624a7ae8a2ba4ce5d8820d9b5f',
    system: 'datalab_pc',
    game_code: 'demo',
    dashboard_title: 'DAU Breakdown',
    description: '',
    user_id: 11625,
    update_user_id: 0,
    user_name: 'jasonzxyin',
    update_user_name: '',
    chart_ids:
      'fa4be1c015fd0cacaf3af3b586ab57319ecb8d0c90dbef1460e253f5086d1cd0',
    publish_status: 0,
    business_type: 0,
    create_time: '2024-05-14 10:52:31',
    update_time: '2024-05-14 10:52:31',
    editable_person: [
      {
        user_id: '2000357',
        user_name: 'jasonzxyin',
        permission: ['edit', 'read', 'delete', 'publish', 'read'],
      },
    ],
    editable_person_name: ['jasonzxyin'],
    access: true,
    read: true,
    edit: true,
    delete: true,
    publish: true,
  },
];
export const ADD_ANALYSIS_DEMO_LIST = [
  {
    table_id: '6a70225a-8697-460e-8a8f-bb216bc6b59c',
    customize_name: '',
    customize_name_en: '',
    table_name: 'game_metric_datalab',
    db_name: 'intelligence_opinion_pre',
    game_code: 'databrain',
    capacity: '3.72 GB',
    sync_status: 0,
    table_desc: '',
    table_desc_en: '',
    label: 'Intelligence',
    sub_label: 'Others',
    creator: 'system',
    create_from: 'sync',
    identifier: '',
    driver: 'bigquery',
    cycle: 'day',
    is_delete: 0,
    columns_info: '',
    use_count: 0,
    create_time: 0,
    modify_time: 0,
    update_time: '0001-01-01T00:00:00Z',
    ExtraDataTableCode: '',
    extra1: '',
    kind: 'physical',
    sql: '',
    query_sql_id: 0,
    is_editable: false,
    template_list: null,
    column_list: [
      {
        name: 'platform',
        type: 'string',
        origin_type: 'STRING',
        display_name: 'platform',
        display_name_en: 'platform',
        remark: '',
        remark_en: '',
        attribute: 1,
        accuracy: 0,
        date_format: '',
        to_date_format: '',
        dimension_setting: 'origin',
        flag: 1,
        is_common_dimension: false,
        is_dimension: true,
        is_metric: false,
        is_sensitive: false,
      },
    ],
    database_uuid: '15000',
  },
];
